const firebaseConfig = {
  apiKey: "AIzaSyC1qPvUbBXia1tSvQz0cXLdMQIzRFE2dlA",
  authDomain: "kawasaki-city-kokuho-test.firebaseapp.com",
  authDomain2: "kawasaki-city-kokuho-test.appspot.com",
  projectId: "kawasaki-city-kokuho-test",
  storageBucket: "kawasaki-city-kokuho-test.appspot.com",
};

export default firebaseConfig;
